import { Editor } from "@tinymce/tinymce-react"
import { Button, Label } from "flowbite-react"
/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { TinyMCE, Editor as TinyMCEEditor } from "tinymce"

import KeyBoardIcon from "@icons/Keyboard"
import { genericUpload } from "@mono/essentials/services/FileUploadServices"

import DangerouslyHTMLTextPriview from "../DangerouslyHTMLTextPriview"

const API_KEY = "m9wksm3irwkkugjjjnuolbw78yiicaul5xaio0k5mtb5iuar"

export type TextEditorOptionsProps = {
  options: string[]
  inline: {
    options: string[]
  }
  textAlign: {
    options: string[]
  }
  list: {
    options: string[]
  }
}

interface TextEditorProps {
  editorOptions?: TextEditorOptionsProps
  name?: string
  value?: any
  ref?: any
  onChange?: (value: any) => void
  toolbarCustomButtons?: any[]
  placeholder?: string
  wrapperClassName?: string
  isDirectLoad?: boolean
}

const RichTextEditor = forwardRef(
  (
    { editorOptions, onChange, value, name, isDirectLoad = true, wrapperClassName, ...props }: any,
    ref
  ) => {
    const fromForwaredRef = !!ref
    const editorRef = useRef<TinyMCEEditor>(null)
    const [showEditor, setShowEditor] = useState(isDirectLoad)

    useImperativeHandle(ref, () => ({
      getContent: () => {
        return editorRef.current.getContent()
      },
      editorLoaded: showEditor,
    }))

    useEffect(() => {
      if (isDirectLoad && !showEditor) {
        setShowEditor(isDirectLoad)
      }
    }, [isDirectLoad])

    const onEditorStateChange = () => {
      if (fromForwaredRef) return
      const value = editorRef.current.getContent()
      onChange?.(value)
    }

    const initProperties = {
      showHeader: false,
      initialValue: value,
      plugins: "image code table lists link advlist",
      menubar: "file edit insert view format table tools",
      image_title: true,
      file_picker_types: "image",
      toolbar:
        "undo redo | bullist numlist outdent indent advlist | link image | code | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
      content_style: `
          @tailwind base;
          @tailwind components;
          @tailwind utilities;
          font-size:
        `,
      images_upload_handler: (blobInfo: any, progress: any) =>
        new Promise((resolve, reject) => {
          const files = new File([blobInfo.blob()], blobInfo.filename(), {
            type: blobInfo.blob().type,
          })
          const formData = new FormData()
          formData.append("file", files)
          const headers = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
          genericUpload(formData, headers)
            .then((blobInfo) => {
              console.log(blobInfo)
              resolve(blobInfo?.data)
            })
            .catch((e) => {
              console.log(e)
              reject(e)
            })
        }),
      height: 300,
      setup(editor: any) {
        editor.on("keydown", (event) => {
          if (event.keyCode == 9) {
            editor.execCommand("mceInsertContent", false, "&emsp;&emsp;")
            event.preventDefault()
            return false
          }
        })
      },
    }
    return (
      <>
        {showEditor ? (
          <div className={`${wrapperClassName}`} key={name}>
            <Editor
              onInit={(evt, editor) => {
                editorRef.current = editor
              }}
              initialValue={value}
              apiKey={API_KEY}
              init={initProperties}
              onBlur={onEditorStateChange}
            />
          </div>
        ) : (
          <div className={"flex w-full justify-between gap-3"}>
            <div className={"border border-neutral-200 rounded-md w-full bg-white"}>
              <div className={"min-h-[88px] pt-2 px-4"}>
                <DangerouslyHTMLTextPriview content={value} />
              </div>
              <div className={"border-t border-neutral-200 p-1 m-auto"}>
                <Button
                  className={"ml-auto"}
                  size={"xs"}
                  color={"ghost"}
                  onClick={() => setShowEditor(true)}
                >
                  <KeyBoardIcon className={"mr-1.5"} />
                  Edit
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
)

export default RichTextEditor
